import PropTypes from 'prop-types';
import React from 'react';
import CarouselLayout from '../../common/components/CarouselLayout';
import BaseContainer from '../../common/components/BaseContainer';

const ProductGroupContainer = props => {
  return <BaseContainer { ...props } Component={ CarouselLayout } />;
};

ProductGroupContainer.propTypes = {
  sectionTitle: PropTypes.string,
  imageCropMethod: PropTypes.string,
  renderMode: PropTypes.string,
  category: PropTypes.string,
  section: PropTypes.string,
  isReseller: PropTypes.bool,
  order: PropTypes.any,
  sampleProductsData: PropTypes.object,
  isInternalPage: PropTypes.bool,
  staticContent: PropTypes.object,
  shopRoute: PropTypes.string,
  domainName: PropTypes.string,
  useStaticData: PropTypes.bool
};

export default ProductGroupContainer;
